/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_realNames.js
// module id = 1659
// module chunks = 1